const getSATSLogo = () =>
  `${window.location.origin}/images/BNB.png`

export default getSATSLogo